// removed by extract-text-webpack-plugin
module.exports = {"root":"_3N8lg","bubble":"euMzf","quote":"_1NYnu","heads":"_2cKel","head":"_2kXLg","active":"_3kh_X","picture":"_2lFdg","triangle":"LT5UX","hidden":"t3qCS","pictureWrapper":"Ob9Nu"};


//////////////////
// WEBPACK FOOTER
// ../source/components/StoryCarousel/styles.css
// module id = 1634
// module chunks = 10